import { EventDetailsQuery } from "./types";

export const beforeRegistrationOpen = (event: EventDetailsQuery["event"]) => new Date() < new Date(event?.registrationOpenAt);

export const afterRegistrationClose = (event: EventDetailsQuery["event"]) => new Date() > new Date(event?.registrationCloseAt);
